import React from 'react';
import LegalPageLayout, { LegalSection } from '../components/legal/LegalPageLayout';
import styles from './LegalPages.module.css';

const NAV_ITEMS = [
  { id: 'terms-use', label: 'Website use' },
  { id: 'terms-products', label: 'Product information' },
  { id: 'terms-quotes', label: 'Quotations & pricing' },
  { id: 'terms-orders', label: 'Orders & delivery' },
  { id: 'terms-ip', label: 'Intellectual property' },
  { id: 'terms-liability', label: 'Liability' },
  { id: 'terms-links', label: 'Third-party links' },
  { id: 'terms-changes', label: 'Changes to terms' },
  { id: 'terms-contact', label: 'Contact' },
];

const TermsAndConditions = () => (
  <LegalPageLayout
    badge="Legal information"
    title="Terms &"
    highlight="Conditions"
    subtitle="These terms govern the use of Greeneri Paper Tradelinks website, product enquiries, and related business communication. By using this website, you agree to the terms below."
    navItems={NAV_ITEMS}
  >
    <LegalSection id="terms-use" number={1} title="Website Use">
      <p className={styles.text}>
        This website is intended for lawful business and informational use. You agree not to misuse the
        site, attempt unauthorized access, or use content in a way that may harm Greeneri Paper
        Tradelinks, its systems, or other users.
      </p>
    </LegalSection>

    <LegalSection id="terms-products" number={2} title="Product Information">
      <p className={styles.text}>
        Product descriptions, specifications, and visuals are provided for general reference. Final
        product parameters including GSM, coating, dimensions, and quantity are confirmed during
        quotation or purchase order stages.
      </p>
    </LegalSection>

    <LegalSection id="terms-quotes" number={3} title="Quotations and Pricing">
      <ul className={styles.list}>
        <li>All quote requests are subject to review and approval.</li>
        <li>Quoted prices may vary based on raw material, quantity, and delivery location.</li>
        <li>Quotes are valid only for the specified period communicated by our team.</li>
      </ul>
    </LegalSection>

    <LegalSection id="terms-orders" number={4} title="Orders, Payment, and Delivery">
      <p className={styles.text}>
        Confirmed orders are processed according to agreed commercial terms. Payment terms, lead times,
        dispatch schedules, and logistics responsibilities are finalized through written business
        communication.
      </p>
    </LegalSection>

    <LegalSection id="terms-ip" number={5} title="Intellectual Property">
      <p className={styles.text}>
        Website content including text, design, branding, and graphics belongs to Greeneri Paper
        Tradelinks unless otherwise stated. Unauthorized copying, distribution, or commercial use is
        prohibited.
      </p>
    </LegalSection>

    <LegalSection id="terms-liability" number={6} title="Limitation of Liability">
      <p className={styles.text}>
        We strive for accurate and updated information, but we do not guarantee uninterrupted or
        error-free website operation. Greeneri Paper Tradelinks is not liable for indirect or
        consequential losses arising from website use.
      </p>
    </LegalSection>

    <LegalSection id="terms-links" number={7} title="Third-Party Links">
      <p className={styles.text}>
        The website may contain links to third-party services (for example maps or social pages). We are
        not responsible for third-party content, policies, or practices.
      </p>
    </LegalSection>

    <LegalSection id="terms-changes" number={8} title="Changes to Terms">
      <p className={styles.text}>
        We may update these terms from time to time. Continued website use after updates constitutes
        acceptance of the revised terms.
      </p>
    </LegalSection>

    <LegalSection id="terms-contact" number={9} title="Contact">
      <p className={styles.text}>
        For terms-related questions, contact <strong>info@greeneripapers.com</strong> or call{' '}
        <strong>+91 9557005492</strong>.
      </p>
    </LegalSection>
  </LegalPageLayout>
);

export default TermsAndConditions;
